// extracted by mini-css-extract-plugin
export default {"title":"K0nZhWgY"};